export function CodigoRastreamentoValidatorDirective($q, Rastreamento) {
  'ngInject';

  return {
    require: 'ngModel',
    link: function (scope, elm, attrs, ctrl) {
      ctrl.$asyncValidators.codigoRastreamento = function (modelValue, viewValue) {
        if (!modelValue || /^\s*$/.test(modelValue)) {
          return $q.resolve();
        }

        return Rastreamento.getRastreio(viewValue).then(function (dados) {
          if (!dados.cliente) {
            throw new Error("sem cliente");
          }
        });
      }
    }
  };
}
